import React from "react";

import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

class ConfirmModal extends React.Component {
  constructor() {
    super();
  }

  render() {
    const {
      title,
      content,
      color,
      isOpen,
      icon,
      confirmButtonText,
      cancelButtonText,
      confirmAction,
      cancelAction,
      afterClose,
      waitForAction,
      isLoading,
      loadingText,
      isSuccess,
      successText,
      isError,
      errorText,
      successTitle
    } = this.props;

    let modalColor = color || "primary";

    let modalIcon = icon;

    let toggleAction = afterClose || cancelAction;

    if (waitForAction && isSuccess) {
      toggleAction = afterClose;
    }

    if (waitForAction && isLoading) {
      toggleAction = () => {};
    }

    let modalContent = content;
    let buttons = (
      <ModalFooter>
        <Button color={modalColor} onClick={confirmAction}>
          {confirmButtonText}
        </Button>
        <Button color="secondary" onClick={toggleAction}>
          {cancelButtonText}
        </Button>
      </ModalFooter>
    );

    if (waitForAction && isLoading) {
      modalContent = <i className="fa fa-circle-o-notch fa-2x fa-spin" />;

      buttons = null;
    }
    if (waitForAction && isError) {
      modalColor = "danger";
    }
    if (waitForAction && isSuccess) {
      modalContent = successText;
      modalColor = "success";
      modalIcon = "check";

      buttons = (
        <ModalFooter>
          <Button color={modalColor} onClick={toggleAction}>OK</Button>
        </ModalFooter>
      );
    }

    return (
      <Modal isOpen={isOpen} toggle={toggleAction}>
        <ModalHeader className={modalColor} toggle={toggleAction}>
          {icon && <i className={"modal-icon fa fa-" + modalIcon} />}
          {isSuccess ? successTitle : isLoading ? loadingText : title}
        </ModalHeader>
        <ModalBody>
          {modalContent}
          <div className="text-danger font-weight-bold">
            {waitForAction && isError && errorText}
          </div>
        </ModalBody>

        {buttons}
      </Modal>
    );
  }
}

export default ConfirmModal;



/** WEBPACK FOOTER **
 ** ./src/browser/components/ConfirmModal/ConfirmModal.js
 **/